var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-treeview', {
    attrs: {
      "items": _vm.items,
      "return-object": "",
      "open-all": ""
    },
    model: {
      value: _vm.items,
      callback: function callback($$v) {
        _vm.items = $$v;
      },
      expression: "items"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }